import { UIGameMapRoadView } from './UIGameMapRoadView.ts';
import { UIGameMapShipView } from './UIGameMapShipView.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ArrayUtils } from '../../../../../shared/utils/ArrayUtils.ts';
import { TileEdgeType } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameMapEdgeController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.updateEdges(data == false);
                break;
            default:
                break;
        }
    }
    updateEdges(drawingExistingEdges = false) {
        this.updateMovedShips();
        this.updateRemovedRoads();
        for (const edge of this.uiGameManager.gameController.mapValidator.tileState.tileEdges){
            if (edge.type == undefined) continue;
            if (this.edgeExists(edge)) continue;
            if (this.shipEdgeExists(edge)) continue;
            this.drawEdge(edge, drawingExistingEdges);
        }
    }
    static playEdgeSound(edge) {
        switch(edge.type){
            case TileEdgeType.Road:
                return AudioManager.play(AudioType.RoadPlace);
            case TileEdgeType.Ship:
                return AudioManager.play(AudioType.ShipPlace);
            default:
                return;
        }
    }
    edgeExists(edge) {
        for (const roadView of this.roadViews){
            if (roadView.edge.sameEdge(edge)) return true;
        }
        return false;
    }
    shipEdgeExists(edge) {
        for (const shipView of this.shipViews){
            if (shipView.edge.sameEdge(edge)) return true;
        }
        return false;
    }
    getExistingViewAtEdge(edge) {
        for (const roadView of this.roadViews){
            if (roadView.edge.sameEdge(edge)) return roadView;
        }
        for (const shipView of this.shipViews){
            if (shipView.edge.sameEdge(edge)) return shipView;
        }
        return undefined;
    }
    updateRemovedRoads() {
        const roads = [
            ...this.roadViews
        ];
        for (const roadView of roads){
            const wasRoadRemoved = roadView.edge.type == undefined;
            if (!wasRoadRemoved) continue;
            roadView.removeView();
            ArrayUtils.removeElementFromArray(this.roadViews, roadView);
        }
    }
    updateMovedShips() {
        const ships = [
            ...this.shipViews
        ];
        for (const shipView of ships){
            const wasShipMoved = shipView.edge.type == undefined;
            if (!wasShipMoved) continue;
            shipView.removeView();
            ArrayUtils.removeElementFromArray(this.shipViews, shipView);
        }
    }
    drawEdge(edge, drawingExistingEdges) {
        const pointerover = ()=>{
            this.highlightLongestRoadIncludingEdge(edge);
        };
        const pointerout = ()=>{
            this.removeLongestRoadHighlight();
            this.resetEdgeViewLayer();
        };
        const toolTipText = ()=>{
            const longestRouteTouchingTileEdges = this.uiGameManager.gameController.mapValidator.getLongestRouteTouchingTileEdge(edge);
            return {
                title: {
                    key: 'strings:colonistCommon.utils.emptyString'
                },
                body: [
                    {
                        key: 'strings:game.tooltips.roadLength',
                        options: {
                            count: longestRouteTouchingTileEdges.length
                        }
                    }
                ]
            };
        };
        if (edge.type == TileEdgeType.Road) {
            const roadView = new UIGameMapRoadView(this.uiGameManager, edge, this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight, this.uiGameManager.mapController.mapView, drawingExistingEdges);
            this.roadViews.push(roadView);
            roadView.executeStartAnimation(edge, drawingExistingEdges, pointerover, pointerout, toolTipText);
            this.uiGameManager.mapController.mapView.sortChildren();
        }
        if (edge.type == TileEdgeType.Ship) {
            const shipView = new UIGameMapShipView(this.uiGameManager, edge, this.uiGameManager.mapController.mapView, drawingExistingEdges);
            this.shipViews.push(shipView);
            shipView.executeStartAnimation(edge, drawingExistingEdges, pointerover, pointerout, toolTipText);
            this.uiGameManager.mapController.mapView.sortChildren();
        }
    }
    highlightLongestRoadIncludingEdge(tileEdge) {
        const longestRouteTouchingTileEdges = this.uiGameManager.gameController.mapValidator.getLongestRouteTouchingTileEdge(tileEdge);
        const layerOffsetToBringToFront = 0.1;
        for (const edge of longestRouteTouchingTileEdges){
            const edgeView = this.getExistingViewAtEdge(edge);
            if (edgeView == undefined) continue;
            edgeView.activateHighlight();
            edgeView.setLayer(layerOffsetToBringToFront);
        }
        this.uiGameManager.mapController.mapView.sortChildren();
    }
    resetEdgeViewLayer() {
        for (const roadView of this.roadViews){
            roadView.setLayer();
        }
        for (const shipView of this.shipViews){
            shipView.setLayer();
        }
        this.uiGameManager.mapController.mapView.sortChildren();
    }
    removeLongestRoadHighlight() {
        for (const roadView of this.roadViews){
            roadView.deactivateHighlight();
        }
        for (const shipView of this.shipViews){
            shipView.deactivateHighlight();
        }
    }
    constructor(uiGameManager){
        this.roadViews = [];
        this.shipViews = [];
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        const drawingExistingEdges = true;
        this.updateEdges(drawingExistingEdges);
    }
}
